module.exports = __webpack_public_path__ + "static/img/banner_07.95033078.png";